import SVG from "../../../Components/SVG";
import Spinner from "../../../Components/Loader/Spinner";

export default function EditButton({
  isEditing = false,
  isSaving = false,
  onEdit,
  onCancel,
  onSave,
}) {
  if (!isEditing) {
    return (
      <div className="w-fit flex items-center gap-2.5">
        <button
          type="button"
          onClick={onEdit}
          onMouseDown={(e) => e.preventDefault()}
          className="group w-fit flex gap-1.5 py-1.5 px-3 rounded-full border border-zi-border-dark/50 dark:border-zi-border-light/50 mb:hocus:border-zi-border-dark mb:hocus:dark:border-zi-border-light"
        >
          <span className="text-xs font-normal text-zi-text-light/50 dark:text-zi-text-dark/50 mb:group-hocus:text-zi-text-light mb:group-hocus:dark:text-zi-text-dark">
            ویرایش
          </span>
          <SVG
            name="edit"
            classname="stroke-zi-text-light/50 dark:stroke-zi-text-dark/50 mb:group-hocus:stroke-zi-text-light mb:group-hocus:dark:stroke-zi-text-dark"
          />
        </button>
      </div>
    );
  }

  return (
    <div className="w-fit flex items-center gap-2.5">
      <button
        type="button"
        onClick={onCancel}
        disabled={isSaving}
        onMouseDown={(e) => e.preventDefault()}
        className="group w-fit flex gap-1.5 py-1.5 px-3 rounded-full border border-amber-400 disabled:cursor-not-allowed disabled:opacity-60"
      >
        <span className="text-xs font-normal text-amber-400">لغو</span>
        <SVG name="close" classname="stroke-amber-400" />
      </button>
      <button
        type="button"
        onClick={onSave}
        disabled={isSaving}
        onMouseDown={(e) => e.preventDefault()}
        className={`group w-fit min-w-16 flex justify-center gap-1.5 py-1.5 px-3 rounded-full border border-cyan-400 disabled:cursor-wait disabled:opacity-80`}
      >
        
        {isSaving ? (
          <div className="flex justify-center items-center px-[16.525px]">
          <Spinner size={18} color="#22d3ee" stroke={2} />
          </div>
        ) : (
          <>
            <span className="text-xs font-normal text-cyan-400">ذخیره</span>
            <SVG name="check" classname="stroke-cyan-400" />
          </>
        )}
      </button>
    </div>
  );
}
